export const ADD_PAYMENT_SCHEDULE = "/payments/:id/add_payment_schedule/";
